import React, {useEffect} from 'react'
import './WachaTv.css'
import Androidscreenshoot from '../images/WachaTv/Androidscreenshoot.png'
import Artboard1 from '../images/WachaTv/Artboard1.png'
import Artboard2 from '../images/WachaTv/Artboard2.png'
import Artboard2s from '../images/WachaTv/Artboard2s.gif'
import Artboard3 from '../images/WachaTv/Artboard3.png'
import Artboard4 from '../images/WachaTv/Artboard4.png'
import Artboard6 from '../images/WachaTv/Artboard6.png'
import Artboard8 from '../images/WachaTv/Artboard8.png'
import Artboard9 from '../images/WachaTv/Artboard9.png'
import Artboard10 from '../images/WachaTv/Artboard10.png'
import Artboard11 from '../images/WachaTv/Artboard11.png'
import Artboard11s from '../images/WachaTv/Artboard11s.gif'
import Artboard12 from '../images/WachaTv/Artboard12.png'
import Artboard13 from '../images/WachaTv/Artboard13.png'
import Artboard14 from '../images/WachaTv/Artboard14.png'
import Artboard15 from '../images/WachaTv/Artboard15.png'
import Artboard16 from '../images/WachaTv/Artboard16.png'
import Artboard17 from '../images/WachaTv/Artboard17.png'
import Artboard18 from '../images/WachaTv/Artboard18.png'
import Artboard19 from '../images/WachaTv/Artboard19.png'
import Artboard20 from '../images/WachaTv/Artboard20.png'
import Artboard21 from '../images/WachaTv/Artboard21.png'
import Artboard22 from '../images/WachaTv/Artboard22.png'
import Footer from '../Component/footer'

 /* import Artboard7 from '../images/WachaTv/Artboard7.png'
     import Artboard23 from '../images/WachaTv/Artboard23.png'
import Artboard24 from '../images/WachaTv/Artboard24.png'
import Artboard25 from '../images/WachaTv/Artboard25.png'
import Artboard26 from '../images/WachaTv/Artboard26.png'
import Artboard27 from '../images/WachaTv/Artboard27.png'
import Artboard28 from '../images/WachaTv/Artboard28.png' */



function WachaTv() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);

    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-WachaTv">
        <div className="client-role-WachaTv">
            <h4 className="client-project-WachaTv">CLIENT</h4>
            <h2 className="portfolio-heading-WachaTv1"> WachaTv</h2>
            <h4 className="role-WachaTv">
            ROLE
            </h4>
            <h2 className="portfolio-role-WachaTv2">UX Designer</h2>
           </div>
            <h4 className="client-details-WachaTv"> DETAILS
            </h4>
            <p className="client-details-WachaTv-p">
            WachaTv Interactive is an original equipment manufacturer offering 
            technology-enhanced solutions, interactive telepresence and digital 
            signage solutions.
            </p>

            <p className="client-details-WachaTv-p2">
            As an African brand focused on providing simple yet durable products, 
            WachaTv aims to be the preferred interactive solutions provider on the continent.

            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2s} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
        
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11s} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard15} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard16} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard17} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard18} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard19} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard20} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard21} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard22} height="auto" width="100%" alt=""/></div>
    {/*
        <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
        <div className="imagevh" id="artboard"><img src={Artboard23} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard24} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard25} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard26} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard27} height="auto" width="100%" alt=""/></div>
    <div className="imagevh" id="artboard"><img src={Artboard28} height="auto" width="100%" alt=""/></div> */}
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}


export default WachaTv
